import * as Enumerable from "linq"
import {LookupValue} from "../../../../models/lookups/lookup.models";
import {LookupUtilities} from "../../../../utilities/lookup-utilities";

export class LookupValueNameValueConverter {

    public toView(value: any, list: LookupValue[]): string {
        if (value) {
            if (!isNaN(Number(value))) {
                const x = Enumerable.from(list).firstOrDefault(x => x.id === value);
                if (x) {
                    return x.name;
                } else {
                    // this means this is a hirarical lookup
                    const matchLookupByIdRecursively = LookupUtilities.matchLookupByIdRecursively(list, value);
                    if (matchLookupByIdRecursively) {
                        return matchLookupByIdRecursively.name;
                    }
                }
            }
        }
        return "";
    }
}